module.exports = __webpack_public_path__ + "img/time-funnel_gold.efbe3abd.png";